import { render, staticRenderFns } from "./select-target2.vue?vue&type=template&id=85a942ec&scoped=true"
import script from "./select-target2.vue?vue&type=script&lang=js"
export * from "./select-target2.vue?vue&type=script&lang=js"
import style0 from "./select-target2.vue?vue&type=style&index=0&id=85a942ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a942ec",
  null
  
)

export default component.exports